"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSuggestion = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const suggestion_button_1 = require("@/components/domains/shared/suggestion-button");
const utils_1 = require("@/utils");
/**
 * 채팅 입력 추천 버튼. mm-button(size=small)을 베이스로 합니다.
 * 클릭 시 chat-suggestion-select 이벤트를 발행합니다.
 */
let ChatSuggestion = class ChatSuggestion extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.handleClick = () => {
            (0, utils_1.emit)(this, 'chat-suggestion-select', { value: (0, suggestion_button_1.resolveSuggestionValue)(this) });
        };
    }
    render() {
        return (0, suggestion_button_1.renderSuggestionButton)(this.icon, this.handleClick);
    }
};
ChatSuggestion.styles = [suggestion_button_1.suggestionButtonStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSuggestion.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSuggestion.prototype, "icon", void 0);
ChatSuggestion = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-suggestion')
], ChatSuggestion);
exports.ChatSuggestion = ChatSuggestion;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1zdWdnZXN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2hhdC1zdWdnZXN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFnQztBQUNoQyxxREFBMkQ7QUFJM0QscUZBSXNEO0FBQ3RELG1DQUE4QjtBQUU5Qjs7O0dBR0c7QUFFSSxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFBdkM7O1FBRXVCLFVBQUssR0FBRyxFQUFFLENBQUE7UUFPOUIsZ0JBQVcsR0FBRyxHQUFHLEVBQUU7WUFDekIsSUFBQSxZQUFJLEVBQUMsSUFBSSxFQUFFLHdCQUF3QixFQUFFLEVBQUUsS0FBSyxFQUFFLElBQUEsMENBQXNCLEVBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO1FBQy9FLENBQUMsQ0FBQTtJQUNILENBQUM7SUFQQyxNQUFNO1FBQ0osT0FBTyxJQUFBLDBDQUFzQixFQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFBO0lBQzVELENBQUM7O0FBTk0scUJBQU0sR0FBRyxDQUFDLDBDQUFzQixDQUFDLENBQUE7QUFDWjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NkNBQVc7QUFDVjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NENBQWdCO0FBSGhDLGNBQWM7SUFEMUIsSUFBQSw2QkFBYSxFQUFDLG9CQUFvQixDQUFDO0dBQ3ZCLGNBQWMsQ0FZMUI7QUFaWSx3Q0FBYyJ9